const state = {
  showLeftMenu: true,
  globalLoading: true,
  menus: [],
  rules: [],
  users: {},
  userGroups: [],
  organizes: [],
  pageSize: 15
}

export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js